import { type KeyboardEvent } from 'react';

import {
  KeyboardControls,
  LARGE_STEP_FACTOR,
  SMALL_STEP_FACTOR,
} from '../../interactions-overlay/constants.js';

export const calculateSelectionDelta = (
  event: KeyboardEvent,
  width: number,
): number => {
  switch (event.key) {
    case KeyboardControls.LEFT_ARROW: {
      const factor = event.shiftKey ? -LARGE_STEP_FACTOR : -SMALL_STEP_FACTOR;
      return width * factor;
    }
    case KeyboardControls.RIGHT_ARROW: {
      const factor = event.shiftKey ? LARGE_STEP_FACTOR : SMALL_STEP_FACTOR;
      return width * factor;
    }
    default:
      return 0;
  }
};
